import { Radio, RadioChangeEvent } from 'antd';
import { useTranslation } from 'react-i18next';
import { ColorSwatchRadioGroup } from '../Ant';
import { TickCircleLinear } from '../icons';
import { ThemeColorKey, themeColors } from '../config/variables';
import { useThemeColor } from '../../context/ThemeColorContext';
import { THEME_COLORS, THEME_COLOR_LABEL_KEYS } from '../../utils/themeColor';
import LabelledRadioGroup from '../labelledRadioGroup/labelledRadioGroup';

interface IThemeColorSwitcherProps {
  onSubmit?: () => void;
}

const ThemeColorSwitcher = ({ onSubmit }: IThemeColorSwitcherProps) => {
  const { t } = useTranslation();
  const { themeColor, setThemeColor } = useThemeColor();

  const handleThemeColorChange = (event: RadioChangeEvent) => {
    setThemeColor(event.target.value as ThemeColorKey);
    onSubmit?.();
  };

  return (
    <LabelledRadioGroup title={t('common:profile.colors')} testId="theme-color-radio">
      <ColorSwatchRadioGroup value={themeColor} onChange={handleThemeColorChange}>
        {THEME_COLORS.map((color) => (
          <Radio key={color} value={color}>
            <span
              className="color-swatch"
              style={{ backgroundColor: `rgb(${themeColors[color].primary})` }}
              data-testid={`theme-color-${color}`}
            >
              {color === themeColor && <TickCircleLinear className="fz-24" />}
            </span>
            <span className="visually-hidden">{t(THEME_COLOR_LABEL_KEYS[color])}</span>
          </Radio>
        ))}
      </ColorSwatchRadioGroup>
    </LabelledRadioGroup>
  );
};

export default ThemeColorSwitcher;
